/**
 * Default template configuration
 * Used as fallback when no specific template matches
 */
import type { TemplateConfig } from '../types'
import { createExpandedRowRender } from '../../expanded-row'
import {
    DEFAULT_FIELDS,
    defaultQuotaCalculator,
    defaultIsExpandable,
} from '../shared'

// Re-export register form
export { default as DefaultRegisterForm } from './register-form'

export const defaultTemplate: TemplateConfig = {
    id: 'default',
    patterns: [/.*/], // Matches everything (fallback)
    priority: -999, // Lowest priority

    fields: DEFAULT_FIELDS,

    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },

    calculateQuota: defaultQuotaCalculator,
}
